module.exports = __webpack_public_path__ + "static/media/iStar.4b2bc8e1.md";